import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { getAllExpeditions } from "../apis/expeditionsAPI"
import { IExpedition } from "../apis/expeditionsAPI/types"

interface ExpeditionsState {
  data: IExpedition[]
  isLoading: boolean
  error: any
}

const initialState: ExpeditionsState = {
  data: [],
  isLoading: false,
  error: null
}

const expeditionsSlice = createSlice({
  name: "expeditions",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      getAllExpeditions.matchFulfilled,
      (state, { payload }) => {
        state.data = payload
      }
    )
  }
})

export const { setLoading, setError } = expeditionsSlice.actions

export default expeditionsSlice
